import React, { useState,useEffect  } from "react";
import { Link } from "react-router-dom";
import CurrencyInput from 'react-currency-input-field';
import { useDataContext } from '../DataContext';

function NumOfRentalProperty() {

  const { updateNumOfRentalProperty } = useDataContext();

  document.title = "SimWealth";

  const [formData, setFormData] = useState({
    propertyValue: 200000,
    monthlyRent: 1900,
    monthlyExpenses: 650,
    appreciationRate: 5,
    inflationRate: 4,
    taxRateOnGainUponSale: 20
  });

  const handleChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    updateNumOfRentalProperty({ formData });
  };

  useEffect(() => {
    updateNumOfRentalProperty({ formData });
  }, [formData]);


  return (
    <>
      <div className="bg bg-num-of-rental-property">
      <div data-aos="fade-right" className="container-fluid row vh-100 w-100">
            <div className=" col-12 col-sm-12 col-md-8 d-flex justify-content-center align-items-start my-auto text-center  ">
                <div className="bg-white rounded-border ms-3 p-4 border border-4 border-dark">
              {/* <div className="col-12 heading-font mb-3">
                        <h1>Personalize Simulation</h1>
                    </div> */}
              <p className="mb-5">
                Enter the numbers of a rental property <br />
                you would like to simulate:
              </p>
              <div className="row mx-4">

                  <div className="d-flex justify-content-end align-items-end mb-3">
                    <label className="fs-18 me-4">Property Value</label>
                    <CurrencyInput
                        id="propertyValue"
                        name="propertyValue"
                        className="rounded"
                        placeholder="$Purchase Price"
                        decimalsLimit={2}                    
                        prefix="$"
                        min={0}
                        intlConfig={{ locale: 'en-US', currency: 'GBP' }}
                        title="Must be 0 or positive number"
                        value={formData.propertyValue}
                        onValueChange={(value, name) => handleChange(value, name)}
                      />
                  </div>

                  <div className="d-flex mb-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Appreciation Rate</label>
                    <CurrencyInput
                      id="appreciationRate"
                      name="appreciationRate"
                      className="rounded"
                      placeholder="Appreciation Rate%"
                      suffix="%"
                      title="Valid range is 0% to 20%"
                      value={formData.appreciationRate}
                      onValueChange={(value, name) => handleChange(value, name)}
                    />
                  </div>

                  <div className="d-flex mb-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Inflation Rate</label>
                    <CurrencyInput
                      id="inflationRate"
                      name="inflationRate"
                      className="rounded"
                      placeholder="Inflation Rate%"
                      suffix="%"
                      title="Valid range is 0% to 20%"
                      value={formData.inflationRate}
                      onValueChange={(value, name) => handleChange(value, name)}
                    />
                  </div>

                  <div className="d-flex mb-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Tax Rate on Gain Upon Sale</label>
                    <CurrencyInput
                      id="taxRateOnGainUponSale"
                      name="taxRateOnGainUponSale"
                      className="rounded"
                      placeholder="Tax Rate on Gain Upon Sale%"
                      suffix="%"
                      title="Valid range is 0% to 20%"
                      value={formData.taxRateOnGainUponSale}
                      onValueChange={(value, name) => handleChange(value, name)}
                    />
                  </div>
                  
                  <div className="d-flex mb-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4">Monthly Rent</label>
                    <CurrencyInput
                        id="monthlyRent"
                        name="monthlyRent"
                        className="rounded"
                        placeholder="$Monthly Rent"
                        decimalsLimit={2}                    
                        prefix="$"
                        min={0}
                        intlConfig={{ locale: 'en-US', currency: 'GBP' }}
                        title="Must be 0 or positive number"
                        value={formData.monthlyRent}
                        onValueChange={(value, name) => handleChange(value, name)}
                      />
                  </div>

                  <div className="d-flex mb-3 justify-content-end align-items-end">
                    <label className="fs-18 me-4 text-end">Monthly Expenses w/o Mortgage Payments</label>
                    <CurrencyInput
                        id="monthlyExpenses"
                        name="monthlyExpenses"
                        className="rounded"
                        placeholder="$Monthly Expenses"
                        decimalsLimit={2}                    
                        prefix="$"
                        min={0}
                        intlConfig={{ locale: 'en-US', currency: 'GBP' }}
                        title="Must be 0 or positive number"
                        value={formData.monthlyExpenses}
                        onValueChange={(value, name) => handleChange(value, name)}
                      />                    
                  </div>

                  

                  

                  

              </div>
              <Link to={'/personalize-simulation/mortgage-information'} 
                    className="threeDButton btn fw-bold  w-50 mt-5">
                    Continue
                </Link>
            </div>
            
          </div>

        </div>
      </div>
    </>
  );
}

export default NumOfRentalProperty;
